import createDuck, {createThunk} from '../utils/actions';
import axios from '../net/axios';
import config from '../config';

const baseUrl = config.api.baseUrl;

const equiposOptionsGetDuck = createDuck('EQUIPOS_OPTIONS_GET');

const equiposOptionsGetThunk = params => {
  const url = `${baseUrl}/v1/equiposOptions`;

  return createThunk(
    axios,
    'get',
    equiposOptionsGetDuck.actions,
    url,
    null,
    params,
  );
};

const equipoGetDuck = createDuck('EQUIPO_GET');

const equipoGetThunk = params => {
  const url = `${baseUrl}/v1/equipo`;

  return createThunk(axios, 'get', equipoGetDuck.actions, url, null, params);
};

const equiposGetDuck = createDuck('EQUIPOS_GET');

const equiposGetThunk = params => {
  const url = `${baseUrl}/v1/equipos`;

  return createThunk(axios, 'get', equiposGetDuck.actions, url, null, params);
};

const equipoCreateDuck = createDuck('EQUIPO_CREATE');

const equipoCreateThunk = params => {
  const url = `${baseUrl}/v1/equipo`;

  return createThunk(axios, 'post', equipoCreateDuck.actions, url, params);
};

const equipoEditDuck = createDuck('EQUIPO_EDIT');

const equipoEditThunk = params => {
  const url = `${baseUrl}/v1/equipo`;

  return createThunk(axios, 'patch', equipoEditDuck.actions, url, params);
};

const equipoDeleteDuck = createDuck('EQUIPO_DELETE');

const equipoDeleteThunk = params => {
  const url = `${baseUrl}/v1/equipo`;

  return createThunk(axios, 'delete', equipoDeleteDuck.actions, url, params);
};

export {
  equipoGetDuck,
  equipoGetThunk,
  equiposGetDuck,
  equiposGetThunk,
  equipoCreateDuck,
  equipoCreateThunk,
  equipoEditDuck,
  equipoEditThunk,
  equipoDeleteDuck,
  equipoDeleteThunk,
  equiposOptionsGetDuck,
  equiposOptionsGetThunk,
};
